// This file contains configuration for the site.
// In a real-world application, this would likely be loaded from environment variables.

export const siteConfig = {
    url: "https://artvau.lt",
};
